import React from 'react';
import { makeStyles } from 'react-scale/components/design-system';
import cx from 'classnames';

interface ImageAttachmentProps {
  imageUrl: string;
  imageDesc?: string;
  onLoadOrError: (error: boolean) => void;
  keepOriginalDimensions?: boolean;
  children?: React.ReactNode;
}

const useStyles = makeStyles({
  wrapperOriginalDimensions: {
    overflow: 'auto',
    position: 'relative',
  },
  imageOriginalDimensions: {
    maxWidth: 'none',
  },
  wrapperDefaultDimensions: {
    paddingRight: 36,
  },
});

const Image: React.FC<ImageAttachmentProps> = ({
  imageUrl,
  imageDesc = '',
  onLoadOrError,
  keepOriginalDimensions = true,
  children,
}) => {
  const classes = useStyles();

  if (keepOriginalDimensions) {
    return (
      <div
        className={cx(classes.wrapperOriginalDimensions, 'task-attachment__item branded-scroll')}
      >
        <div>{imageDesc}</div>
        <img
          className={classes.imageOriginalDimensions}
          onLoad={() => {
            onLoadOrError(true);
          }}
          onError={() => {
            onLoadOrError(false);
          }}
          src={imageUrl}
        />
        {children}
      </div>
    );
  } else {
    return (
      <div className={classes.wrapperDefaultDimensions}>
        <div>{imageDesc}</div>
        <img
          className="task-attachment__item"
          onLoad={() => {
            onLoadOrError(true);
          }}
          onError={() => {
            onLoadOrError(false);
          }}
          src={imageUrl}
        />
        {children}
      </div>
    );
  }
};

export default Image;
